export default __webpack_public_path__ + "static/media/ken.dca5b57b.jpeg";